export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "auth.worker.4347013468a7f505886f.worker.js");
}
